import { type ReactNode, useId } from "react";
import { useTranslation } from "react-i18next";

type HaNSearchResultGroupProps = {
  title: string;
  allCount: number;
  canExpand: boolean;
  isExpanded: boolean;
  onToggleExpanded: () => void;
  children: ReactNode;
};

export const HaNSearchResultGroup = ({
  title,
  allCount,
  canExpand,
  isExpanded,
  onToggleExpanded,
  children,
}: HaNSearchResultGroupProps) => {
  const { t } = useTranslation();
  const titleId = useId();
  const listId = useId();

  return (
    <section
      aria-labelledby={titleId}
      className="mx-5 flex flex-col gap-1 border-b py-3">
      <div className="flex items-center justify-between py-1 text-sm">
        <h3
          id={titleId}
          className="text-mapiq-black-500 text-sm">
          {title}
        </h3>

        {canExpand && (
          <button
            type="button"
            aria-expanded={isExpanded}
            aria-controls={listId}
            className="rounded-sm font-semibold text-collaborative-blue-500 hover:text-collaborative-blue-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-mapiq-black-900"
            onClick={onToggleExpanded}>
            {isExpanded ? t("ShowLess") : t("hereAndNow:ShowAllResults", { count: allCount })}
          </button>
        )}
      </div>

      <ul
        id={listId}
        className="-mx-2 flex flex-col gap-2">
        {children}
      </ul>
    </section>
  );
};
